module.exports = __webpack_public_path__ + "ce9d7a5e33169ef158fcaf68e4ee6dc0.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/gallery/scarring/scarring-1a.jpg
 ** module id = 443
 ** module chunks = 0
 **/